module.exports = __webpack_public_path__ + "img/icon-mentorreception.31d8a30e.svg";